import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import { useApp } from '@/context/AppContext';
import MaskSizing from '@/components/MaskSizing';

export default function MedicionStep() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, updateEleccionProgress } = useApp();
  const { maskRecommendation, maskSizing } = state.eleccion;

  // Track current mask sizing step state
  const [maskSizingStep, setMaskSizingStep] = useState<{
    step: 'method' | 'measure' | 'manual';
    measureMethod: 'regla' | 'manual' | null;
    previousStep: 'method' | 'measure' | 'manual' | null;
  }>({ step: 'method', measureMethod: null, previousStep: null });

  // Handle header back button clicks
  useEffect(() => {
    const handleHeaderBack = () => {
      const { step } = maskSizingStep;
      
      if (step === 'measure' || step === 'manual') {
        // Go back to method selection
        setMaskSizingStep(prev => ({ ...prev, step: 'method', previousStep: null }));
        window.dispatchEvent(new CustomEvent('maskSizingStepChange', { 
          detail: { action: 'goToMethod' } 
        }));
      } else {
        // From method selection, go back to breathing results screen
        navigate('/eleccion/respiracion-resultados');
      }
    };

    window.addEventListener('headerBackClick', handleHeaderBack);
    return () => window.removeEventListener('headerBackClick', handleHeaderBack);
  }, [navigate, maskSizingStep]);

  const completeMaskSizing = (sizingResult: {
    maskSize: 'S' | 'M' | 'L';
    measurementMm: number;
    measureMethod: 'regla' | 'manual';
    borderline: boolean;
  }) => {
    updateEleccionProgress({ maskSizing: sizingResult });
    navigate('/eleccion/medicion-resultado');
  };

  const handleBack = () => {
    // Go back to breathing results screen to show mask recommendation
    navigate('/eleccion/respiracion-resultados');
  };

  const handleStepChange = useCallback((stepInfo: {
    step: 'method' | 'measure' | 'manual';
    measureMethod: 'regla' | 'manual' | null;
    previousStep: 'method' | 'measure' | 'manual' | null;
  }) => {
    setMaskSizingStep(stepInfo);
  }, []);

  return (
    <MaskSizing 
      maskType={maskRecommendation as 'Nasal' | 'Oronasal'} 
      onComplete={completeMaskSizing} 
      onBack={handleBack}
      onStepChange={handleStepChange}
    />
  );
}